// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  fetchQuesCreateChapterPending: false,
  fetchQuesCreateChapterError: null,
  fetchQuesCreateChapterSuccess: null,
  fontSize: 16,
  fetchSubmitQuesPending: false,
  fetchSubmitQuesError: null,
  fetchSubmitQuesSuccess: null,
  fetchGetQuesChapterPending: false,
  fetchGetQuesChapterError: null,
  checkParsIndex: new Set(),
  checkAllPars: false,
  curQuesIndex: 0,
  fetchSubmitPraPending: false,
  fetchSubmitPraError: null,
  fetchSubmitPraSuccess: null,
  fetchQuesContinueChapterPending: false,
  fetchQuesContinueChapterError: null,
  fetchQuesExamPending: false,
  fetchQuesExamError: null,
  fetchQuesExamSuccess: null,
  fetchGetExamQuesListPending: false,
  fetchGetExamQuesListError: null,
  fetchGetExamQuesListSuccess: null,
  totalQues: 0,
  totalScore: 0,
  baseIndexArr: [],
  questions: [],
  fetchGetExamDetailPending: false,
  fetchGetExamDetailError: null,
  fetchGetExamDetailSuccess: null,
  fetchGetExamPageResultPending: false,
  fetchGetExamPageResultError: null,
  QuestionTypeIndex: 0,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/ques-store/redux/initialState.js